import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  BUTTON: `${cleanedFilename(__filename)}-button`,
  INPUT: `${cleanedFilename(__filename)}-input`,
};
